import React from 'react';

import { useFormContext } from 'react-hook-form';
import { Collapse, Grid } from '@mui/material';

import { CabinEventReport, EventFormStatus, ReportType } from '../../../core/api/clients';

import AttachmentList from '../../../components/AttachmentList';
import ControlledTextField from '../../../components/ControlledTextField';
import { useCabinEventReportData } from '../../../core/context/CabinEventReportDataContext';
import { useAuthorizedFormData } from '../../../core/context/AuthorizedFormDataContext';

function NarrativeStep({ visible, readOnly }: { visible: boolean, readOnly?: boolean }) {
  const { control } = useFormContext<CabinEventReport>();
  const { cabinEventReport, allowedActions } = useCabinEventReportData();
  const authorizedFormData = useAuthorizedFormData();
  return (
    <Collapse in={visible}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ControlledTextField<CabinEventReport>
            control={control}
            name="narrative"
            TextFieldProps={{
              multiline: true,
              rows: 6,
            }}
            readOnly={readOnly}
            rules={{ required: true }}
            disableEditPopper={!allowedActions?.edit}
          />
        </Grid>
        <Grid item xs={12}>
          <AttachmentList
            reportType={ReportType.CabinEventReport}
            reportId={cabinEventReport.id}
            allowedActions={allowedActions}
          />
        </Grid>
        {cabinEventReport.status !== EventFormStatus.Draft && (authorizedFormData.isApprover || authorizedFormData.isAdministrator) && (
          <Grid item xs={12}>
            <ControlledTextField<CabinEventReport>
              control={control}
              name="approverComments"
              TextFieldProps={{
                multiline: true,
                rows: 6,
              }}
              readOnly={readOnly}
              rules={{ required: true }}
              disableEditPopper={!allowedActions?.edit}
            />
          </Grid>
        )}
      </Grid>
    </Collapse>
  );
}

export default NarrativeStep;
